import { createSignal } from 'solid-js';
import { useNavigate } from '@solidjs/router';

export default function StudentJoin() {
  const [code, setCode] = createSignal('');
  const navigate = useNavigate();

  const submit = (e: Event) => {
    e.preventDefault();
    const value = code().trim().toUpperCase();
    if (!value) return;
    navigate(`/q/${value}`);
  };

  return (
    <div class="container" style={{ 'max-width': '480px' }}>
      <h2 class="mb-3">Join a Quiz</h2>
      <form onSubmit={submit} class="card p-3">
        <label class="form-label">Enter quiz code</label>
        <input
          type="text"
          class="form-control"
          value={code()}
          onInput={(e) => setCode(e.currentTarget.value.toUpperCase())}
          placeholder="e.g. ABC123"
          pattern="[A-Z0-9]{4,10}"
          required
        />
        <button type="submit" class="btn btn-primary mt-3">Join</button>
      </form>
    </div>
  );
}
